import { getMe, postLogout } from '@/api/auth.api';
import { useAuthStore } from '@/store/auth.store';

// API-driven orchestration around the auth store. checkAuth() dedupes
// concurrent calls (single in-flight probe), logout() clears the flag
// after the server ack. The store itself stays a plain state holder —
// no fetches inside a Pinia store, per api-client.md rule.
let _authCheckPromise: Promise<void> | null = null;

function useAuth() {
    const authStore = useAuthStore();

    async function checkAuth(): Promise<void> {
        if (_authCheckPromise) {
            return _authCheckPromise;
        }
        _authCheckPromise = (async () => {
            try {
                await getMe();
                authStore.setAuthenticated(true);
            } catch {
                authStore.setAuthenticated(false);
            }
        })();
        return _authCheckPromise;
    }

    async function logout(): Promise<void> {
        try {
            await postLogout();
        } finally {
            authStore.setAuthenticated(false);
            _authCheckPromise = null;
        }
    }

    return { checkAuth, logout };
}

// Test-only reset for the module-level dedup promise.
export { useAuth };
